<app-navbar title="VALIDAÇÃO DE AUTENTICIDADE" [btnBack]="true" [btnConfig]="true">

</app-navbar>

<main class="container">

    <p-card>

        <ng-template pTemplate="header">

            <div class="row">

                <div class="col-12 col-sm-6">
                    <i class="fa-solid fa-stamp"></i>
                    CONFERÊNCIA DE AUTENTICIDADE DE PDF
                </div>

            </div>

        </ng-template>

        <form id="formPesquisar" [formGroup]="myForm">

            <div class="row">

                <div class="col-12 col-sm-6">

                    <div class="row">

                        <div class="col-12 col-sm-4 text-end">
                            <label><b>CÓDIGO VERIFICADOR:</b></label>
                        </div>

                        <div class="col-12 col-sm-8">
                            <input
                                formControlName="codigo_verificacao"
                                type="text"
                                class="form-control form-control-sm">
                        </div>

                        <div class="col-12 col-sm-4 text-end" style="margin-top: 20px;">
                            <label><b>PDF:</b></label>
                        </div>

                        <div class="col-12 col-sm-8" style="margin-top: 20px;">

                            <input
                                type="file"
                                accept="application/pdf"
                                class="form-control form-control-sm"
                                (change)="onFileSelected($event)">

                        </div>

                        <div class="input_field captch_box">

                            <input
                                type="text"
                                [value]="captchaGenerate"
                                disabled />

                            <button
                                class="refresh_button"
                                type="button"
                                (click)="refreshBtnClick()">

                                <i
                                    class="fa-solid fa-rotate-right"
                                    style="color: white">
                                </i>

                            </button>

                        </div>

                        <div class="input_field captch_input">

                            <input
                                type="text"
                                formControlName="captcha"
                                placeholder="Digite o texto acima..." />

                        </div>

                        <div class="input_field button">

                            <button
                                type="button"
                                [disabled]="myForm.invalid"
                                (click)="submitBtnClick()">

                                VALIDAR

                            </button>

                        </div>

                    </div>

                </div>

                <div class="col-12 col-sm-6">

                    <div class="row">

                        <div class="col-12 col-sm-12 text-center">

                            <i
                                class="fa-solid fa-circle-info"
                                style="color: #ffad33; padding-right: 10px;"
                                tooltipPosition="top">
                            </i>

                            <label>
                                <b>
                                    INFORME O CÓDIGO VERIFICADOR E REALIZE O UPLOAD
                                    DO PDF GERADO PARA VALIDAR A AUTENTICIDADE
                                    DO DOCUMENTO.
                                </b>
                            </label>

                        </div>

                        <div class="col-12 col-sm-12 text-center">

                            <img
                                style="max-width: 100%;"
                                src="../../../assets/img/qr-code.png" />

                        </div>

                    </div>

                </div>

            </div>

        </form>

    </p-card>

    <p-card *ngIf="resultado.length">

        <ng-template pTemplate="header">

            <div class="row">

                <div class="col-12 col-sm-6">
                    VALIDAÇÃO
                </div>

            </div>

        </ng-template>

        <p-table
            styleClass="gord-datatable"
            [value]="resultado"
            [paginator]="true"
            [columns]="cols_validacao"
            [rows]="10"
            [showCurrentPageReport]="true"
            [tableStyle]="{ 'min-width': '50rem' }"
            currentPageReportTemplate="Mostrando {first} de {last} / Total: {totalRecords}"
            [rowsPerPageOptions]="[10, 25, 50]"
            dataKey=""
        >

            <ng-template pTemplate="header" let-columns>

                @if(resultado && resultado.length ){

                    <tr>

                        @for (col of columns; track $index) {

                            <th
                                [ngClass]="col.class"
                                [style]="{ width: col.width }">

                                @switch (col.header) {

                                    @default {

                                        <div class="d-flex align-items-center">
                                            {{col.header}}
                                        </div>

                                    }

                                }

                            </th>

                        }

                    </tr>

                }

            </ng-template>

            <ng-template
                pTemplate="body"
                let-item
                let-columns="columns"
                let-expanded="expanded"
                let-index="rowIndex">

                <tr>

                    <td *ngFor="let col of columns">

                        @switch (col.field) {

                            @default {
                                {{ item[col.field] }}
                            }

                        }

                    </td>

                </tr>

            </ng-template>

            <ng-template pTemplate="emptymessage">

                <tr>

                    <td colspan="4">
                        <p></p>
                        NENHUM REGISTRO ENCONTRADO NOS PARÂMETROS INFORMADOS.
                        <br>
                    </td>

                </tr>

            </ng-template>

        </p-table>

    </p-card>

</main>